<template>
<div class='widget-W0134V0001'>
  <div class="widget-container default-theme" :class="{'admin-theme' : userProfile == 'employee'}">

    <!-- Logo -->
    <div class="widget-header">
      <img src="data:image/png;base64,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" alt="klubkort" />
    </div>

    <!-- Login Fallback -->
    <div v-if="dataFetchFailed && aulaToken">
      <form :action="aioUrl" method="GET" target="_blank">
        <input type="hidden" name="return" value="" />
        <input type="hidden" name="aulaToken" :value="aulaToken" />
        <input type="hidden" name="userProfile" :value="userProfile" />

        <button class="widget-login-button" type="submit" aria-label="Gå til klubkort oversigt">
          <span class="mr-8">Gå til Klubkort</span>
          <i aria-hidden="true" class="fa-solid fa-arrow-right"></i>
        </button>
      </form>
    </div>

    <!-- Error Box -->
    <div class="error-container" v-if="errors.length">
      <div v-for="error of errors" class="widget-error">
        <span>{{error}}</span>
      </div>
    </div>

    <!-- Children -->
    <div v-if="childInfo && !loading">
      <div v-for="(child, i) of childInfo.Wallets">
        <!-- Child Name -->
        <button v-if="userProfile != 'child'" :aria-label="(child.expand ? 'Skjul' : 'Vis') + ' bestillinger for ' + child.Name" class="widget-child-name" @click="toggleChild(child)"><i aria-hidden="true" class="fa-solid fa-user mr-8"></i>{{child.Name}}</button>
        <hr />

        <div class="widget-child-info" :class="{expand : child.expand}">
          <!-- Balance -->
          <div class="balance-container">
            <div class="balance">
              <div class="balance-title">Saldo</div>
              <div class="balance-value">{{currency(child.Balance.Amount)}}</div>
            </div>
            <div class="balance" v-if="child.Balance.Credit">
              <div class="balance-title">Tilskud</div>
              <div class="balance-value">{{currency(child.Balance.Credit)}}</div>
            </div>
          </div>


          <!-- Add NFC -->
          <form :action="aioUrl" method="GET" target="_blank" v-if="!child.NFCAdded && aulaToken">
            <input type="hidden" name="return" value="" />
            <input type="hidden" name="aulaToken" :value="aulaToken" />
            <input type="hidden" name="userProfile" :value="userProfile" />
            <input type="hidden"
                   name="returnUrl"
                   :value="'/NFC/Index?WalletID=' + child.WalletID" />

            <button class="missing-card-info" type="submit" :aria-label="'Tilføj klubkort for ' + child.Name">
              <strong>Vigtigt:</strong> Der er ikke tilføjet et klubkort til kontoen.
              <strong>Tryk her for at tilføje.</strong>
            </button>
          </form>

          <!-- NFC Added -->
          <div v-if="child.NFCAdded">
            <div class="nfc-added"><span class="fa fa-check nfc-check" aria-hidden="true"></span> Klubkort er tilføjet til konto</div>
          </div>

          <!-- Account Links -->
          <div class="account-child-info">
            <div class="account-buttons">
              <form :action="aioUrl" method="GET" target="_blank" v-if="aulaToken">
                <input type="hidden" name="return" value="" />
                <input type="hidden" name="aulaToken" :value="aulaToken" />
                <input type="hidden" name="userProfile" :value="userProfile" />
                <input type="hidden"
                       name="returnUrl"
                       :value="'/DepositWithdraw/Deposit?WalletID=' + child.WalletID" />

                <button class="account-button" type="submit" :aria-label="'Optank saldo for ' + child.Name">
                  Optank Saldo
                </button>
              </form>
              <form :action="aioUrl" method="GET" target="_blank" v-if="aulaToken">
                <input type="hidden" name="return" value="" />
                <input type="hidden" name="aulaToken" :value="aulaToken" />
                <input type="hidden" name="userProfile" :value="userProfile" />
                <input type="hidden"
                       name="returnUrl"
                       :value="'/Webshop/Index?WalletID=' + child.WalletID" />

                <button class="account-button" type="submit" :aria-label="'Køb webshop-produkter for ' + child.Name">
                  Webshop
                </button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- No Users -->
    <div class="error-container" v-if="!childCount && !loading">
      <div class="widget-error">
        <span>Der blev ikke fundet nogen brugere tilknyttet denne konto</span>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div class="loading-container" v-if="loading">
      <i aria-hidden="true" class="fa-solid fa-spinner loading-spinner"></i>
    </div>
  </div>
</div>
</template>

<style lang="scss">
.widget-W0134V0001 {
button {
  color: #fff;
  background-color: rgb(69, 147, 194);
  border: 1px solid rgb(69, 147, 194);
  border-radius: 0;
  font-weight: 600;
  transition: none;
  box-shadow: none !important;
}

button:hover {
  color: rgb(255, 255, 255);
  background: rgb(40, 113, 159);
  border-color: rgb(40, 113, 159);
}

button:active {
  background: #18638F;
  border-color: #18638F;
}

button.active {
  background: #153854;
  border-color: #153854;
  pointer-events: none;
}

button[disabled="disabled"] {
  background-color: transparent !important;
  color: rgba(16, 16, 16, 0.3) !important;
  border-color: rgba(118, 118, 118, 0.3) !important;
  pointer-events: none !important;
}

.admin-theme button {
  background-color: #45B7C1;
  border: 1px solid #45B7C1;
}

.admin-theme button:hover {
  color: rgb(255, 255, 255);
  background: #2091A2;
  border-color: #2091A2;
}

.admin-theme button:active {
  background: #007A8D;
  border-color: #007A8D;
}

.admin-theme button.active {
  background: #222350;
  border-color: #222350;
  pointer-events: none;
}

.error-container {
  margin: 10px;
}

.nfc-added {
  font-size: 12px;
  font-weight: 600;
  padding: 0 8px 10px 8px;
}

.nfc-check {
  margin-right: 4px;
  display: inline-block;
}

hr {
  margin: 16px 0;
}

.widget-header {
  background: #222350;
  padding: 16px 0;
  text-align: center;
}

.widget-header img {
  width: 162px;
  position: relative;
}

.widget-error {
  color: rgb(255, 255, 255);
  background: rgb(181, 0, 80);
  padding: 5px;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
}

.widget-container {
  background: #ffffff;
  padding: 10px;
  color: #222350;
}

.widget-child-name {
  cursor: pointer;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  text-align: left !important;
  font-weight: 500 !important;
  color: #222350 !important;
  font-weight: 600 !important;
  margin-top: 20px;
  width: 100%;
}

.widget-child-name:hover {
  text-decoration: underline;
}

.widget-child-info {
  display: none;
}

.widget-child-info.expand {
  display: block;
}

.account-buttons {
  display: flex;
  margin-bottom: 10px;
}

.account-buttons form {
  flex: 1;
  display: flex;
}

.account-buttons form:first-child {
  margin-right: 5px;
}

.account-buttons form:last-child {
  margin-left: 5px;
}

.account-button {
  flex: 1;
  padding: 10px;
}

.widget-order-button,
.widget-login-button {
  padding: 10px 15px;
  margin-bottom: 10px;
  width: 100%;
}

.widget-container .fa-solid {
  font-family: 'Font Awesome 5 Pro';
  font-style: initial;
}

.widget-container .loading-container {
  padding: 40px;
  text-align: center;
}

.widget-container .loading-spinner {
  font-size: 30px;
  animation: loading-spinner 2s ease infinite;
  display: inline-block;
}

.missing-card-info {
  font-size: 12px;
  margin-top: 8px;
  border: 2px solid rgb(245, 69, 16) !important;
  background: rgba(245, 69, 16, 0.22) !important;
  padding: 8px;
  color: rgb(34, 35, 80) !important;
  white-space: initial;
  text-align: left;
  font-weight: 400;
  margin-bottom: 8px;
}

.missing-card-info:hover,
.missing-card-info:active,
.missing-card-info:focus {
  color: #fff !important;
  border: 2px solid rgb(245, 69, 16) !important;
  background: rgba(245, 69, 16, 1) !important;
}

.mr-8 {
  margin-right: 8px;
}

.balance-container {
  display: flex;
  margin-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 16px;
}

.balance {
  flex: 1;
  padding: 0 8px;
}

.balance-title {
  font-size: 12px;
}

.balance-value {
  font-weight: 600;
}

@keyframes loading-spinner {
  0% {
    transform: rotateZ(0deg);
  }

  50% {
    transform: rotateZ(180deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

@-moz-keyframes loading-spinner {
  0% {
    transform: rotateZ(0deg);
  }

  50% {
    transform: rotateZ(180deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

@-webkit-keyframes loading-spinner {
  0% {
    transform: rotateZ(0deg);
  }

  50% {
    transform: rotateZ(180deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

@media screen and (min-width:992px) and (max-width:1200px) {

  .widget-login-button {
    font-size: 14px;
  }

  .widget-child-name,
  .widget-container {
    font-size: 14px;
  }
}
}
</style>
<script>

export default {
  props: {
    axios: Function,
    getAulaToken: Function,
    userProfile: String,
    childFilter: Array,
    moment: Function
  },
  data: () => {
    return {
      errors: [],
      loading: true,
      dataFetchFailed: false,
      aulaToken: null,
      childInfo: {},
      childCount: null,
      activeChild: null,
      activeProduct: null,
      apiUrl: "https://kkapi.pay4it.dk/V2/Wallet/AulaClubInfo",
      aioUrl: "https://skolemad-klub.kk.dk/aula/login?return",
    }
  },
  methods: {
    getChildren() {
      var date = this.moment().format();

      this.loading = true;
      this.dataFetchFailed = false;

      this.axios
        .post(this.apiUrl,
          {
            aulaToken: this.aulaToken,
            childs: this.childFilter,
            date: date
          }
        )
        .then((response) => {
          this.errors = [];
          this.childInfo = response.data;
          this.childCount = 0;

          if (this.childInfo.Wallets) {
            this.childCount = this.childInfo.Wallets.length;

            this.childInfo.Wallets.forEach((c, i) => {
              c.expand = true;
              c.Balance = {
                Amount: parseFloat(c.WalletBalance),
                Credit: parseFloat(c.CreditBalance)
              }
            });
          }
        })
        .catch((e) => {
          this.errors.push(e);
          this.dataFetchFailed = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleChild(child) {
      child.expand = !child.expand;
    },
    selectWeek(week) {
      this.getChildren(week);
    },
    currency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK'
      });
      return formatter.format(value);
    },
  },
  mounted() {
    this.aulaToken = this.getAulaToken();
  },
  watch: {
    aulaToken: function () {
      if (this.aulaToken != undefined) {
        this.getChildren();
      }
    },
  },
};
</script>
